const viewMoreElement = document.querySelector('.js-btn-load-more');

if (viewMoreElement) {
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting && !entry.target.hasAttribute('disabled')) {
        // Stop observing immediately so appending new products (and any
        // resulting layout shift) can't retrigger this before the click's
        // own disabled/hidden state settles.
        observer.unobserve(entry.target);
        entry.target.click();
      }
    }
  });
  observer.observe(viewMoreElement);

  // Resume observing once loading finishes (disabled attribute is removed),
  // so infinite scroll keeps working for further pages as the user scrolls.
  const attrObserver = new MutationObserver(() => {
    if (viewMoreElement.hasAttribute('disabled')) return;

    const parent = viewMoreElement.closest('collection-load-more');
    if (parent?.classList.contains('hidden')) return; // last page

    observer.observe(viewMoreElement);
  });
  attrObserver.observe(viewMoreElement, { attributes: true, attributeFilter: ['disabled'] });
}
